import React from 'react';

const styles = {
    body: {
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        backgroundColor: '#f4f7f6',
        margin: 0,
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
    },
    container: {
        backgroundColor: '#ffffff',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '100%',
    },
    h1: {
        color: '#28a745',
        fontSize: '2.5em',
        marginBottom: '10px',
    },
    p: {
        color: '#555',
        fontSize: '1.1em',
        lineHeight: '1.6',
    },
    reviewLink: {
        display: 'inline-block',
        marginTop: '30px',
        padding: '15px 30px',
        backgroundColor: '#007bff',
        color: '#ffffff',
        textDecoration: 'none',
        fontWeight: 'bold',
        borderRadius: '8px',
        transition: 'background-color 0.3s ease',
    },
    reviewLinkHover: {
        backgroundColor: '#0056b3',
    },
    closeNotice: {
        marginTop: '30px',
        fontSize: '0.9em',
        color: '#888',
    }
};

function PaymentSuccess() {
    return (
        <div style={styles.body}>
            <div style={styles.container}>
                <h1 style={styles.h1}>Thank You!</h1>
                <p style={styles.p}>Your payment was successful. We appreciate your business.</p>
                <p style={styles.p}>A copy of your receipt has been emailed to you.</p>
                <p style={styles.p}>If you were happy with our service, please take a moment to leave us a review on Google. Your feedback helps us grow!</p>
                <a 
                    href="https://search.google.com/local/writereview?placeid=ChIJs7LBP1guWIgRjzn92x9dEa8" 
                    style={styles.reviewLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    onMouseOver={e => e.currentTarget.style.backgroundColor = styles.reviewLinkHover.backgroundColor}
                    onMouseOut={e => e.currentTarget.style.backgroundColor = styles.reviewLink.backgroundColor}
                >
                    Leave a Review
                </a>
                <p style={styles.closeNotice}>You may now close this window.</p>
            </div>
        </div>
    );
}

export default PaymentSuccess;
